var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('p',{staticClass:"notice fn-sm"},[_vm._v(" * 依統一發票使用辦法規定，個人戶無法換開為公司戶發票，公司戶發票也無法換為個人戶發票 ( "),_c('a',{staticClass:"underline",attrs:{"href":`${_vm.baseUrl}/Member/eInvoiceChart`,"target":"_blank"}},[_vm._v(" 財政部電子發票流程說明 ")]),_vm._v(" ) ")]),_c('p',{staticClass:"fn-sm"},[_vm._v("* 若為預購商品，發票將於商品出貨後再行開立")])])
}
var staticRenderFns = []

export { render, staticRenderFns }